import * as localizations from "./localizations";
export const appStrings = localizations;

export * from "./components/LocalizedRoutes";
export * from "./components/LocalizedRouter";
export * from "./components/NavigationLink";
export * from "./components/LocalizedSwitcher";
